import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {HistoricalValuePresentationDTO} from '../../../api';
import {HistoricalValuesService} from '../services/historical-values.service';
import {isNullOrUndefined} from 'util';
import {ColorHelper} from '@swimlane/ngx-charts';
import {COLOR_DOMAIN} from '../historical-values-grid/colorDomain';
import {formatDate} from '@angular/common';

const LOCALE_DE = 'de-DE';

@Component({
  selector: 'app-historical-values-graph',
  templateUrl: './historical-values-graph.component.html',
  styleUrls: ['./historical-values-graph.component.scss']
})
export class HistoricalValuesGraphComponent implements OnInit, OnChanges {

  @Input() dataSeries: any[];

  private filterInformation;
  private historicalValues: Array<HistoricalValuePresentationDTO>;

  colorScheme = {
    domain: COLOR_DOMAIN
  };
  customColors: any;
  showLegend = true;

  public curveData: any[];
  public originalProductList: Set<any>;
  public filteredDataSeries: any[];
  public data: any[];
  public originalData: any[];
  public activeProducts: any[] = [];
  public shownSeriesNames: any[];

  yAxisMin: number;
  yAxisMax: number;

  legendOptions = {
    names: [],
    colors: undefined,
  };

  constructor(private historicalValuesService: HistoricalValuesService) {
  }

  ngOnInit() {
    this.registerFilteringEvents();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.historicalValues = changes.dataSeries.currentValue;
      this.buildGraph(this.historicalValues);
    }
  }

  public buildGraphData(historicalValues: Array<HistoricalValuePresentationDTO>) {
    const productsData = new Map<string, {
      flavorName: string,
      marketHubName: string,
      periodDivisionLabel: string,
      productName: string,
      productTypeName: string,
      productYear: number
    }>();

    historicalValues.forEach((value: HistoricalValuePresentationDTO) => {
      productsData.set(value.productName, {
        flavorName: value.flavorName,
        marketHubName: value.marketHubName,
        periodDivisionLabel: value.periodDivisionLabel,
        productName: value.productName,
        productTypeName: value.productTypeName,
        productYear: value.productYear
      });
    });
    // this.originalProductList;
    const originalProductList: Set<any> = new Set<any>();
    productsData.forEach((value) => {
      originalProductList.add(value);
    });
    this.originalProductList = originalProductList;
    // filter the products

    return this.getGraphSeriesByProductsData(productsData);
  }

  public onLegendLabelClick(event) {
    const idx = this.shownSeriesNames.findIndex((serie) => serie.name === event);
    const idxCurve = this.curveData.findIndex((serie) => serie.name === event);
    if (idx < 0) {
      const idxActive = this.filteredDataSeries.find((serie) => serie.name === event);
      this.shownSeriesNames.push({name: event});
      this.curveData.push(idxActive);
    } else {
      this.shownSeriesNames.splice(idx, 1);
      this.curveData.splice(idxCurve, 1);
    }
    this.triggerListChange(this.curveData, this.shownSeriesNames);
  }

  triggerListChange(curveData, showSeries) {
    this.curveData = [...curveData];
    this.shownSeriesNames = [...showSeries];
  }

  private prepareGraphData() {
    const me = this;
    this.data = [];
    this.originalData.forEach((entry, index) => {
      if (me.activeProducts[index] === true) {
        me.data.push(entry);
      }
    });
    this.recalculateYAxisEdges();
  }

  private initActiveProducts() {
    const me = this;
    this.activeProducts = [];
    this.originalData.forEach((value, index) => {
      me.activeProducts[index] = true;
    });
  }

  private recalculateYAxisEdges() {
    const me = this;
    let yAxisMin = 100;
    let yAxisMax = 0;
    this.data.forEach(value => {
      value.series.forEach(histoValue => {
        if (histoValue > me.yAxisMax) {
          yAxisMax = histoValue;
        }
        if (histoValue < me.yAxisMin) {
          yAxisMin = histoValue;
        }
      });
    });
    this.yAxisMax = yAxisMax;
    this.yAxisMin = yAxisMin;
    this.data = [...this.data];
  }

  getSeriesToolTipHeaderText(model) {
    // return (model[0]) ? moment(model[0].name).format('DD.MM.Y') : '';
  }

  getToolTipText(tooltipItem: any): string {
    // overwrite getToolTipText() default behavior
    let result = '';
    if (tooltipItem.series !== undefined) {
      result += tooltipItem.series;
    }
    if (tooltipItem.value !== undefined) {
      result += ': ' + tooltipItem.value.toLocaleString(LOCALE_DE);
    }
    return result;
  }

  public getSinglePointTooltipName(tooltipSingleItem) {
    return 'Produkt: ' + tooltipSingleItem.series;
  }

  public getSinglePointTooltipDate(tooltipSingleItem) {
    // return 'Datum: ' + moment(tooltipSingleItem.name).format('DD.MM.Y');
  }

  public getSinglePointTooltipPrice(tooltipSingleItem) {
    return 'Preis: ' + tooltipSingleItem.value.toLocaleString(LOCALE_DE);
  }

  private registerFilteringEvents() {
    this.historicalValuesService.filterSource$.subscribe(value => {
      this.filterInformation = value;
      this.legendOptions.colors = new ColorHelper(this.colorScheme, 'ordinal', [], null);
      this.buildGraph(this.historicalValues);
    });
  }

  private buildGraph(historicalValues: Array<HistoricalValuePresentationDTO>) {
    this.originalData = this.buildGraphData(historicalValues);
    this.filteredDataSeries = [...this.originalData];
    this.initActiveProducts();
    this.prepareGraphData();
    this.applyFilters(this.filterInformation);
  }

  private applyFilters(filters: any[]) {
    if (filters) {
      const me = this;
      const filteredProducts = [];
      this.originalProductList.forEach((value) => {
        if (me.compareProductWithFilters(value, filters)) {
          filteredProducts.push(value);
        }
      });
      this.filteredDataSeries = [...this.getGraphSeriesByProductsData(filteredProducts)];
      this.refreshLegendInfo();
    }
  }

  private compareProductWithFilters(value: HistoricalValuePresentationDTO, filters) {
    const marketHubFilteringResult: { filter: string, checked: boolean } = filters.filtersData.marketHubs.find(
      (currentMarketHub: { filter: string, checked: boolean }) => {
        return value.marketHubName === currentMarketHub.filter;
      });
    if (marketHubFilteringResult === undefined || marketHubFilteringResult.checked === false) {
      return false;
    }

    if (filters.filtersData.flavors) {
      const flavorFilteringResult: { filter: string, checked: boolean } = filters.filtersData.flavors.find(
        (currentFlavor: { filter: string, checked: boolean }) => {
          return value.flavorName === currentFlavor.filter;
        });
      if (flavorFilteringResult === undefined || flavorFilteringResult.checked === false) {
        return false;
      }
    }

    const yearsFilteringResult: { filter: string, checked: boolean } = filters.filtersData.years.find(
      (currentYear: { filter: string, checked: boolean }) => {
        return value.productYear === +currentYear.filter;
      });
    if (yearsFilteringResult === undefined || yearsFilteringResult.checked === false) {
      return false;
    }

    const periodDivFilteringResult: { filter: string, checked: boolean } = filters.filtersData.periodDivisions.find(
      (currentPeriodDivision: { filter: string, checked: boolean }) => {
        return value.periodDivisionLabel === currentPeriodDivision.filter;
      });
    if (periodDivFilteringResult === undefined || periodDivFilteringResult.checked === false) {
      return false;
    }
    return true;
  }

  private getGraphSeriesByProductsData(productsDataSet) {
    const dataInt: { series: any[], name: string }[] = [];

    productsDataSet.forEach((seriesName: {
      flavorName: string,
      marketHubName: string,
      periodDivisionLabel: string,
      productName: string,
      productTypeName: string,
      productYear: number
    }) => {
      const myArray = this.dataSeries.filter((historicalValue: HistoricalValuePresentationDTO) => {
        return historicalValue.productName === seriesName.productName;
      });

      dataInt.push({
        name: seriesName.productName,
        series: myArray.map((historicalValue: HistoricalValuePresentationDTO) => {
          return {
            'name': new Date(historicalValue.settlementDate),
            'value': historicalValue.settlementValue
          };
        })
      });
    });
    return dataInt;
  }

  private refreshLegendInfo() {
    if (this.showLegend) {
      this.legendOptions.names = [];
      this.shownSeriesNames = [];
      const shownSeriesOnGraph = [];
      this.customColors = [];
      if (!isNullOrUndefined(this.filteredDataSeries)) {
        for (let i = 0; i < this.filteredDataSeries.length; i++) {
          this.legendOptions.names.push(this.filteredDataSeries[i].name);
          this.customColors.push({
            name: this.filteredDataSeries[i].name,
            value: this.legendOptions.colors.colorDomain[i]
          });

          shownSeriesOnGraph.push(this.filteredDataSeries[i]);
          this.shownSeriesNames.push({name: this.filteredDataSeries[i].name});
        }
        this.curveData = [...shownSeriesOnGraph];
        this.shownSeriesNames = [...this.shownSeriesNames];
      }
    }
  }

  public getXAxisTickFormatting(params) {
    // return moment(params).locale('de').format('MMMM YY');
    return 'Oct 18';
  }

}
